@if (stepError()) {
  <div class="sensitive-message-error">
    <lucide-icon name="triangle-alert" [size]="14" />
    <span>{{ stepErrorMessage() }}</span>
  </div>
} @else if (
  !sensitiveDataItems().length &&
  !_sensitiveDataContentService.isLoading()
) {
  <div class="sensitive-message-wait-value">
    <div class="text">
      {{
        (_permissionsService.hasOnlyViewerPermissions()
          ? 'sensitiveDataInput.descriptionViewer'
          : 'sensitiveDataInput.description'
        ) | labelsProvider
      }}
    </div>
  </div>
} @else {
  <div class="sensitive-message-field-value-container">
    @if (_sensitiveDataContentService.isLoading()) {
      <div class="sensitive-message-block-spinner">
        <mat-progress-spinner
          [diameter]="42"
          class="spinner"
          mode="indeterminate" />
      </div>
    } @else {
      <div
        #sensitiveData
        class="sensitive-message-field-value sensitive-message__sensitive-data"
        [class.expanded]="sensitiveDataExpanded()">
        @for (
          sensitiveDataItem of sensitiveDataItems();
          track sensitiveDataItem
        ) {
          @if (!$first) {
            <img
              class="icon-field-sensitive"
              src="assets/images/status-icons/attention.svg"
              height="16"
              [matTooltip]="
                sensitiveIconToolTipLabelPath
                  | labelsProvider
              " />
          }

          {{ sensitiveDataItem }}
        }
      </div>

      @if (isContentCollapsible()) {
        <div
          class="sensitive-message__read-more"
          (click)="
            $event.stopPropagation();
            sensitiveDataExpanded.set(
              !sensitiveDataExpanded()
            )
          ">
          <span>{{
            sensitiveDataExpanded()
              ? 'Read less'
              : 'Read more'
          }}</span>
          <lucide-icon
            [name]="
              sensitiveDataExpanded()
                ? 'chevron-up'
                : 'chevron-down'
            "
            [size]="14" />
        </div>
      }
    }
  </div>
}
